import {Dialog} from "primereact/dialog";
import React from "react";
import Editor from "@monaco-editor/react";
import {ScheduledTaskDTO} from "api/model/airflow-task/ScheduledTaskDTO";

namespace TemplateInfoDialog {
    export type Props = {
        taskCfg: ScheduledTaskDTO,
        visible: boolean,
        setVisible: (visible: boolean) => void,
    }
}

export default function TemplateInfoDialog(props: TemplateInfoDialog.Props ) {
    const templateInfo = props.taskCfg?.templateInfo
    const codeDecoded = atob(templateInfo.definition?.codeFile?.content || '')

    return <Dialog header="Template info dialog"
                   visible={props.visible}
                   style={{width: 'min(650px, 50vw)'}}
                   footer={<div></div>} // dialog bottom padding
                   onHide={() => props.setVisible(false)}
    >
        <div className="p-fluid grid formgrid">
            <div className="p-field p-col-4">
                <h5>Template ID</h5>
                <span>{templateInfo.templateId}</span>
            </div>

            <div className="p-field p-col-4">
                <h5>Template Version</h5>
                <span>{templateInfo.templateVersion}</span>
            </div>

            <div className="p-field p-col-4">
                <h5>Template Type</h5>
                <span>{templateInfo.type}</span>
            </div>

            <div className="p-field p-col-12">
                <h4>Code decoded</h4>
                <Editor
                    height="650px"
                    defaultLanguage="python"
                    value={codeDecoded}
                    theme="vs-dark"
                />
            </div>
        </div>
    </Dialog>
}